export const FixFormValues = (values) => {
    const keys = Object.keys(values);
    for (let i = 0; i < keys.length; ++i) {
        let k = keys[i];
        if (values[k] && typeof values[k] === 'object' && typeof values[k].label !== 'undefined' && typeof values[k].value !== 'undefined') {
            values[k] = values[k].value;
        }
    }

    return values;

};
